import React from "react";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error("ErrorBoundary caught an error:", error);
    
    this.setState({
      error,
      errorInfo,
    });

    // You can also log the error to an error reporting service here
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-sm">
                <Card.Body className="text-center p-5">
                  <div className="mb-4">
                    <FeatherIcon
                      icon="alert-circle"
                      size={64}
                      className="text-danger"
                    />
                  </div>
                  <h3 className="mb-3">Something went wrong</h3>
                  <p className="text-muted mb-4">
                    We encountered an unexpected error. Please try reloading the page.
                  </p>
                  
                  {process.env.NODE_ENV === "development" && this.state.error && (
                    <div className="mb-4 text-start">
                      <details className="bg-light p-3 rounded">
                        <summary className="fw-bold mb-2">Error Details (Development Only)</summary>
                        <pre className="small text-danger mb-2">
                          {this.state.error.toString()}
                        </pre>
                        {this.state.errorInfo && (
                          <pre className="small text-muted" style={{ maxHeight: "200px", overflow: "auto" }}>
                            {this.state.errorInfo.componentStack}
                          </pre>
                        )}
                      </details>
                    </div>
                  )}

                  <div className="d-flex gap-2 justify-content-center">
                    <Button variant="primary" onClick={this.handleReload}>
                      <FeatherIcon icon="refresh-cw" size={16} className="me-2" />
                      Reload Page
                    </Button>
                    <Button variant="outline-secondary" onClick={this.handleGoHome}>
                      <FeatherIcon icon="home" size={16} className="me-2" />
                      Go Home
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

